// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;

    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

window.posiExpandFeatherlightShortcode = function (e) {
  var shortcode = e.$content.text();

  e.$content.text("");
  $.post({
    url: window.SITE_SETTINGS.ajaxurl,
    data: {
      action: "posi_expand_shortcode",
      shortcode: shortcode,
    },
    success: function (result) {
      e.$content.html(result);

      var hsTO = false;
      function awaitLoadHubspot() {
        hsTO = setTimeout(function () {
          if (window.hubspot) window.hbsptReady();
          else awaitLoadHubspot();
        }, 100);
      }
      awaitLoadHubspot();
    },
  });
};

// add norel automatically
(function ($) {
  var domainUrl = window.location.origin;
  $("a")
    .not(
      'a[href*="' +
        domainUrl +
        '"], a[href*="mailto:"], a[href*="tel:"], a[href*="javascript:;"], a[href^="?"] '
    )
    .attr({
      target: "_blank",
      rel: "nofollow noreferrer",
    });
})(jQuery);

jQuery(function ($) {
  function removeUnwantedTrailingSlash(all) {
    var selector = all ? "a" : ".no-trailing-slash";
    $(selector).each(function (i, el) {
      var href = $(el).attr("href");
      if (href && href.charAt(href.length - 1) == "/")
        $(el).attr("href", href.substring(0, href.length - 1));
    });
  }
  window.removeUnwantedTrailingSlash = removeUnwantedTrailingSlash;

  $(document).on("mousemove.removetrailingslash", function () {
    $(document).off("mousemove.removetrailingslash");
    setTimeout(function () {
      removeUnwantedTrailingSlash(true);
    }, 500);
  });
});

module.exports = {
  debounce,
};
